<div class="width-100">
  <div fxLayout="row" class="margin-bottom-4" fxLayoutAlign="space-between center">
    <p class="font-sm font-bold margin-0">What do you want to do?</p>
    <mat-icon (click)="close()" class="cursor-pointer">close</mat-icon>
  </div>

  <mat-radio-group
    aria-labelledby="hosting-group-label"
    class="hosting-radio-group margin-bottom-4"
    (change)="selectedHosting($event)">
    <mat-radio-button
      *ngFor="let type of hostingTypes"
      class="hosting-radio-button"
      [disableRipple]="true"
      [checked]="type.hosted"
      [value]="type.hosted">
      <span class="sparro-grey-800 font-sm">
        {{ type.title }}
      </span>
      <span>
        <i class="icon-info" [matTooltip]="type.info" matTooltipPosition="left"></i>
      </span>
    </mat-radio-button>
  </mat-radio-group>

  <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="16px">
    <uni-navigation-button default="Cancel" button_class="secondary" (click)="close()">
    </uni-navigation-button>

    <uni-navigation-button default="Next" button_class="primary" (click)="save()">
    </uni-navigation-button>
  </div>
</div>
